export const TOAST_TYPE = {
  success: "success",
  warning: "warning",
  error: "error",
  info: "info",
};

export const TOAST_MESSAGE_KEY = {
  badRequest: "badRequest",
  unauthorized: "unauthorized",
  serverError: "serverError",
  unexpected: "unexpected",
  failRetrieve: "failRetrieve",
  failSend: "failSend",
  successClaimSave: "successClaimSave",
  successPersonalInfoSave: "successPersonalInfoSave",
};
